import React from "react";
import { Helmet } from "react-helmet-async";
const SchemaComponent = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "How will Invisalign® treatment straighten my teeth?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A unique, digital treatment plan that maps out the exact movements of your teeth is created. Your Invisalign® clear aligners are then designed to apply the right amount of force to the right place at the right time based on your plan. We will be with you every step of the way to monitor your progress and ensure your aligners fit correctly.",
        },
      },
      {
        "@type": "Question",
        name: "How long will treatment take?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The length of treatment depends on multiple factors, like how complex your case is and how often you wear your aligners. We will determine how long your treatment could take based on your specific needs. On average, Invisalign® treatment time is 6 to 18 months though you can start seeing results in a matter of weeks.",
        },
      },
      {
        "@type": "Question",
        name: "Are there any restrictions on what I can eat while in treatment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "None! Invisalign® clear aligners are removable, so there are no food restrictions at all. With traditional wires and brackets, there’s a long list of foods you unfortunately can’t enjoy, as they can damage or get stuck in your braces.",
        },
      },
      {
        "@type": "Question",
        name: "Is Invisalign® better than braces?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Both are options. In some instances, braces are better suited than Invisalign®, in others Invisalign® is a better option. It also depends on your lifestyle and what fits for you. A consultation with our dentist will help you choose the right option for you.",
        },
      },
      {
        "@type": "Question",
        name: "Can you drink water with Invisalign®?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. You can drink any drink with Invisalign®. If it’s a hot drink or a drink that could stain the aligners, then its advised to remove them to have the drink and then put them back in. If its water, then you wouldn’t need to remove your aligners.",
        },
      },
      {
        "@type": "Question",
        name: "How much does Invisalign® cost and do you offer finance?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Like other types of orthodontic treatment, the price of the Invisalign® treatment depends on the complexity of your dental correction and your course of treatment.The dental practice do have finance options and you can discuss these with one of the treatment co-ordinators as part of your consultation.",
        },
      },
      {
        "@type": "Question",
        name: "Is Invisalign® treatment painful?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Invisalign® treatment moves your teeth by applying gentle, constant force, but some people do feel temporary discomfort for the first few days of wearing a new set of aligners.Typically, people describe it as feeling “pressure” and it’s normal — it’s a sign your Invisalign® clear aligners are working and transforming your smile.If you do have any concerns you will be able to get in touch with one of the team who will be able to discuss your concerns.",
        },
      },
      {
        "@type": "Question",
        name: "What are the advantages of Invisalign®?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Invisalign® provides a discreet option to straighten your teeth. It also allows you to straighten your teeth with minimal interference on your day-to-day life – so you can eat, drink and enjoy the things as normal.",
        },
      },
      {
        "@type": "Question",
        name: "Does Invisalign® change your face shape?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Invisalign® uses thin plastic trays so this shouldn’t have any impact on your visual appearance. The discretion that Invisalign® provides is one of the key benefits.",
        },
      },
    ],
  };

  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://www.invisalign-ilkley.com/#organization",
    headline:
      "Diamond Apex Invisalign® Teeth Straightening in Ilkley West Yorkshire",
    url: "https://www.invisalign-ilkley.com/",
    name: "Invisalign-Ilkley",
    description:
      "Local Dentist in Kington Herefordshire - “ this part of it will be replaced with “Local Dentist in Ilkley, West Yorkshire",
    inLanguage: "en-UK",
    author: { "@id": "https://www.invisalign-ilkley.com/#organization" },
    creator: { "@id": "https://www.invisalign-ilkley.com/#organization" },
    publisher: { "@id": "https://www.invisalign-ilkley.com/#organization" },
    provider: { "@id": "https://www.invisalign-ilkley.com/#organization" },
    mentions: [
      "https://en.wikipedia.org/wiki/Clear_aligners#Invisalign",
      "invisalign teeth",
    ],
  };
  const schemaData3 = {
    "@context": "https://schema.org/",
    "@type": "LocalBusiness",
    name: "Invisalign Ilkley",
    url: "https://www.invisalign-ilkley.com/",
    sameAs: [
      "https://www.instagram.com/regentdental_ilkley/",
      "https://www.facebook.com/photo/?fbid=122134911068498469&set=a.122134911104498469/",
    ],
    address: {
      "@type": "PostalAddress",
      streetAddress: "2A Regent Rd",
      addressLocality: "Ilkley",
      postalCode: "LS29 9EA",
      addressCountry: "UK",
    },
    telephone: "+01943 661331",
    openingHours: "Mo-saturday 09:00-17:00",
    image:
      "https://www.invisalign-ilkley.com/static/media/header-logo.d5abac7d7e76717023d1.png",
  };
  const schemaData4 = {
    "@context": "https://schema.org/",
    "@type": "Service",
    name: "Invisalign®",
    description:
      "Invisalign® is a modern and virtually invisible orthodontic treatment that straightens teeth using custom-made, clear aligners. Designed for comfort and flexibility, Invisalign® offers an effective alternative to traditional braces, ideal for both teens and adults.",
    url: "https://www.invisalign-ilkley.com/",
    provider: {
      "@type": "Organization",
      name: "Regent Dental",
      url: "https://www.invisalign-ilkley.com/",
    },
  };
  const schemaData5 = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Person",
        name: "Dr. Naiz",
        jobTitle: "Cosmetic Dentist",
        url: "https://www.invisalign-ilkley.com/",
        image:
          "https://www.invisalign-ilkley.com/static/media/albert.5e50b16ed6465b2aa335.png",
      },
      {
        "@type": "Person",
        name: "Dr. Naeem",
        jobTitle: "Cosmetic Dentist",
        url: "https://www.invisalign-ilkley.com/",
        image:
          "https://www.invisalign-ilkley.com/static/media/lucinda.c21129b8f70b1a05ec2c.png",
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData2)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData3)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData4)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData5)}</script>
    </Helmet>
  );
};

export default SchemaComponent;
